import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { storeWriteSettingsAdapts, StoreWriteSettingsAdapter } from './store-write-settings.adapter';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { AzureBlobFSWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/azure-blob-fs-store-write-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobFSWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts,
        blockSizeInMB: '*',
        metadata: '*'
    }
})
export class AzureBlobFSWriteSettingsAdapter extends StoreWriteSettingsAdapter<
    AzureBlobFSWriteSettings,
    Model.StoreWriteSettings
> {
    protected override async _toResource(model: AzureBlobFSWriteSettings): Promise<Model.StoreWriteSettings> {
        const result: Model.StoreWriteSettings = await super._toResource(model);
        StoreWriteSettingsAdapter.toStoreWriteSettingsResource(model, result);
        this._commonPropsToResource(result, model);
        return result;
    }

    protected override async _toModel(
        resource: Model.StoreWriteSettings,
        copySink: CopySink
    ): Promise<AzureBlobFSWriteSettings> {
        const result = await super._toModel(resource, copySink);
        StoreWriteSettingsAdapter.toStoreWriteSettingsModel(resource, result);
        this._commonPropsToModel(resource, result, copySink);
        return result;
    }
}
